<template>
    <div>
        <el-button type="primary" icon="el-icon-circle-plus-outline" @click="_save">添加</el-button>
        <el-table v-loading="datas.status == -1" :data="datas.data" @sort-change="_sort" @selection-change="_select">
            <el-table-column prop="id" label="ID" width="100" sortable="custom"></el-table-column>
            <template v-for="(item, index) in mix_fields">
                <el-table-column :label="item.COLUMN_COMMENT" :width="item.width ? item.width : 'auto'" :key="index">
                    <template slot-scope="scope">
                        <div>
                            {{ scope.row[item.COLUMN_NAME] }}
                        </div>
                    </template>
                </el-table-column>
            </template>
            <el-table-column label="编号">
                <template slot-scope="scope">
                    <el-input v-model="scope.row.code" @blur="_quick_edit(table, scope.row.id, 'code', scope.row.code)">
                    </el-input>
                </template>
            </el-table-column>
            <el-table-column label="排序">
                <template slot-scope="scope">
                    <el-input v-model="scope.row.myorder"
                        @blur="_quick_edit(table, scope.row.id, 'myorder', scope.row.myorder)">
                    </el-input>
                </template>
            </el-table-column>
            <el-table-column width="150" label="操作">
                <template slot-scope="scope">
                    <div class="handle-box">
                        <el-button type="text" @click="_save(scope.row.id)">编辑</el-button>
                        <el-button type="text" @click="_del(scope.row.id)" class="c-danger">删除</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <ls-table-data :table="table" @fields="e => { mix_fields = e }"></ls-table-data>
        <ls-mask title="权限管理" @close="show_save = false" v-if="show_save" width="80vw">
            <el-form>
                <el-form-item label="标题">
                    <el-input v-model="r.title"></el-input>
                </el-form-item>
                <el-form-item label="标题1">
                    <el-input v-model="r.title1"></el-input>
                </el-form-item>
                <el-form-item label="权限">
                    <el-checkbox-group v-model="r.rules">
                        <el-checkbox v-for="(item, index) in rules" :key="index" :label="item.id">
                            {{ item.title }}（{{ item.controller }}）
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="菜单">
                    <el-checkbox-group v-model="r.menu_ids">
                        <el-checkbox v-for="(item, index) in menus" :key="index" :label="item.id">
                            {{ item.title }}
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="_submit">提交</el-button>
                </el-form-item>
            </el-form>
        </ls-mask>
    </div>
</template>
<script>
export default {
    data() {
        return {
            table: 'admin_group',
            rules: [],
            menus: [],
            r: {
                rules: [],
                menu_ids: []
            },
            datas: {
                order: {
                    myorder: 'asc',
                    id: 'asc'
                },
                add: {}
            }
        };
    },
    created() {
        this._load();
        this._rules();
        this._menus();
    },
    methods: {
        _submit() {
            // let arr = this.$refs.tree.getCheckedNodes(false, false);
            // this.r.menu_ids = [];
            // arr.map(item => {
            //     this.r.menu_ids.push(item.id);
            // })
            this.$http.post(`admin_group/${this.r.id ? 'edit' : 'add'}`, this.r).then(res => {
                if (res.code) {
                    this.show_save = false;
                    this._load();
                }
            })
        },
        _menus() {
            this.$http.post('admin_menus/list').then(res => {
                this.menus = res.data.data;
            })
        },
        _rules() {
            this.$http.post('admin_rule/list', {
                limit: 1000,
                is_rule: 1,
                // is_show: 1,
                order: {
                    'controller': 'asc',
                    'action': 'asc'
                }
            }).then(res => {
                this.rules = res.data.data;
            })
        }
    },
};
</script>
<style lang="scss"></style>